export const landToElementModule = {
  name: 'Land To Element',
};
